<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>Customer Profile | Master</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
<br>
<!-- main row for all icons  -->
<div class="col-lg-12">
<div class="row">
<div class="col-lg-4 flex">
<div class="card card-danger ">
		<div class="card-header">
			<h5>Profile</h5>
		</div>
		<div class="card-body overflow-auto">
			<form @submit.prevent="updateCustomer">
						<div :class="['form-group', errors.name ? 'has-error' : '']">
							<label>Name</label>
							<input type="text" class="form-control" placeholder="Enter the customer name" v-model="form.name">
							<span v-if="errors.name" :class="['badge bg-danger']">Please enter a valid name.</span>
						</div>
						<div :class="['form-group', errors.gender ? 'has-error' : '']">
							<label>Gender</label>
							<select class="form-control" placeholder="Select customer gender" v-model="form.gender">
								<option value="M">Male</option>
								<option value="F">Female</option>
							</select>
							<span v-if="errors.gender" :class="['badge bg-danger']">Please choose a valid gender.</span>
						</div>
						<div :class="['form-group', errors.mobile ? 'has-error' : '']">
							<label>Phone 1</label>
							<input type="text" class="form-control" placeholder="Enter phone 1" v-model="form.mobile">
							<span v-if="errors.mobile" :class="['badge bg-danger']">Please enter a valid phone number.</span>
						</div>
						<div :class="['form-group', errors.alt_mobile ? 'has-error' : '']">
							<label>Phone 2</label>
							<input type="text" class="form-control" placeholder="Enter phone 2" v-model="form.alt_mobile">
							<span v-if="errors.alt_mobile" :class="['badge bg-danger']">Please enter a valid phone number.</span>
						</div>
						<div :class="['form-group', errors.phone ? 'has-error' : '']">
							<label>Phone 3</label>
							<input type="text" class="form-control" placeholder="Enter phone 3" v-model="form.phone">
							<span v-if="errors.phone" :class="['badge bg-danger']">Please enter a valid phone number.</span>
						</div>
						<div :class="['form-group', errors.alt_phone ? 'has-error' : '']">
							<label>Phone 4</label>
							<input type="text" class="form-control" placeholder="Enter phone 4" v-model="form.alt_phone">
							<span v-if="errors.alt_phone" :class="['badge bg-danger']">Please enter a valid phone number.</span>
						</div>
						<div :class="['form-group', errors.email ? 'has-error' : '']">
							<label>E-mail</label>
							<input type="email" class="form-control" placeholder="Enter email address" v-model="form.email">
							<span v-if="errors.email" :class="['badge bg-danger']">Please enter a valid email.</span>
						</div>
						<div :class="['form-group', errors.alt_email ? 'has-error' : '']">
							<label>Alt E-mail</label>
							<input type="text" class="form-control" placeholder="Enter alternate email address" v-model="form.alt_email">
							<span v-if="errors.alt_email" :class="['badge bg-danger']">Please enter a valid email.</span>
						</div>
						<div :class="['form-group', errors.dob ? 'has-error' : '']">
							<label>DOB</label>
							<input type="date" class="form-control" placeholder="Enter date of birth" v-model="form.dob">
							<span v-if="errors.dob" :class="['badge bg-danger']">Please enter a valid dob.</span>
						</div>
						<div :class="['form-group', errors.membership_id ? 'has-error' : '']">
							<label>Membership ID</label>
							<input type="text" class="form-control" placeholder="Enter membership ID" v-model="form.membership_id">
							<span v-if="errors.membership_id" :class="['badge bg-danger']">Please enter a valid membership ID.</span>
						</div>
						<div :class="['form-group', errors.category ? 'has-error' : '']">
							<label>Category</label>
							<input type="text" class="form-control" placeholder="Enter the category" v-model="form.category">
							<span v-if="errors.category" :class="['badge bg-danger']">Please enter a valid category.</span>
						</div>
						<div :class="['form-group', errors.area ? 'has-error' : '']">
							<label>Area</label>
							<input type="text" class="form-control" placeholder="Enter the area" v-model="form.area">
							<span v-if="errors.area" :class="['badge bg-danger']">Please enter a valid area.</span>
						</div>
						<div :class="['form-group', errors.doa ? 'has-error' : '']">
							<label>DOA</label>
							<input type="text" class="form-control" placeholder="Enter DOA" v-model="form.doa">
							<span v-if="errors.doa" :class="['badge bg-danger']">Please enter a valid doa.</span>
						</div>
						<div class="form-group">
							<button class="btn btn-danger" type="submit">Submit</button>
						</div>
						</form>

			<!-- content here -->

    </div>
    </div>

</div>
<div class="col-lg-8 flex">
	<div class="card card-danger ">
		<div class="card-header">
			<div class="col-sm-8">
			<div class="row">
				<h5>Addresses</h5>
				<button class="btn btn-danger float-right" @click="add"><i class="fa fa-plus"></i> Add Address</button>
			</div>
			</div>
		</div>
		<div class="card-body overflow-auto">
				<table class="table table-striped table-bordered table-hover">
						<thead>
							<tr>
								<th>Address</th>
								<th>City</th>
								<th>State</th>
								<th>Pincode</th>
								<th>Manage</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="j in addresses" :key="j.id">
								<td>{{j.addr_l1}}, {{j.addr_l2}}, {{j.addr_l3}}</td>
								<td>{{j.city}}</td>
								<td>{{j.state}}</td>
								<td>{{j.pincode}}</td>
								<td>
									<button class="btn btn-danger fa fa-edit" @click="change(j)"></button>
									<button class="btn btn-danger fa fa-trash" @click="deleteA(j.id)"></button>
								</td>
							</tr>
						</tbody>
					</table>
    </div>
    <div class="card-body">
    						<table class="table table-striped table-bordered table-hover">
									<thead>
										<tr>
											<th scope="col">Doc. Name</th>
											<th scope="col">Doc. Number</th>
											<th scope="col">Front</th>
											<th scope="col">Back</th>
											<th scope="col">Notes</th>
											<th scope="col">Valid Till</th>
											<th scope="col">Validity</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="doc in documents">
											<td>{{doc.doc_name}}</td>
											<td>{{doc.doc_no}}</td>
											<td>{{doc.doc_front}}</td>
											<td>{{doc.doc_back}}</td>
											<td>{{doc.notes}}</td>
											<td>{{doc.valid_till}}</td>
											<td>{{doc.validity}}</td>
										</tr>
									</tbody>
								</table>
    </div>
    <div class="card card-danger">
					<div class="card-body">
						<div class="form-group">
							<label>Doc Name</label>
							<input class="form-control" v-model="doc_name" placeholder="Enter the document name" type="text">
							<span class="badge badge-danger" v-if="errors.doc_name">Please enter a valid document name</span>
						</div>
						<div class="form-group">
							<label>Doc Number</label>
							<input class="form-control" v-model="doc_number" placeholder="Enter the document number" type="text">
							<span class="badge badge-danger" v-if="errors.doc_num">Please enter a valid document number</span>
						</div>
						<div class="form-group">
							<label>Front Image</label>
							<input class="form-control" placeholder="Add the front image" type="file" id="front" ref="front" @change="addFront">
							<span class="badge badge-danger" v-if="errors.front">Please upload a valid image</span>
						</div>
						<div class="form-group">
							<label>Back Image</label>
							<input class="form-control" placeholder="Add the back image" type="file" id="back" ref="back" @change="addBack">
							<span class="badge badge-danger" v-if="errors.back">Please upload a valid image</span>
						</div>
						<div class="form-group">
							<label>Notes</label>
							<input class="form-control" v-model="notes" placeholder="Enter notes" type="text">
							<span class="badge badge-danger" v-if="errors.notes">Please enter valid notes</span>
						</div>
						<div class="form-group">
							<label>Valid Till</label>
							<input class="form-control" v-model="valid_till" placeholder="Enter the valid till date" type="date">
							<span class="badge badge-danger" v-if="errors.valid_till">Please enter a valid date</span>
						</div>
						<div class="form-group">
							<button class="btn btn-primary" @click="addDocument">Submit</button>
						</div>
					</div>
				</div>
	</div>
</div>
</div>
</div>
</section>

<div class="modal" tabindex="-1" role="dialog" id="adrsmodal">
 <div class="modal-dialog" role="document">
 <div class="modal-content">
 <div class="modal-header">
        <h5 class="modal-title">{{heading}} Details</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
					<div class="modal-body">
						<form @submit.prevent="updateAddress">
						<div :class="['form-group', errors.addr_l1 ? 'has-error' : '']">
							<label>Address Line 1</label>
							<input type="text" class="form-control" placeholder="Enter address line 1" v-model="aform.addr_l1">
							<span v-if="errors.addr_l1" :class="['badge bg-danger']">Please enter a valid line.</span>
						</div>
						<div :class="['form-group', errors.addr_l2 ? 'has-error' : '']">
							<label>Address Line 2</label>
							<input type="text" class="form-control" placeholder="Enter address line 2" v-model="aform.addr_l2">
							<span v-if="errors.addr_l2" :class="['badge bg-danger']">Please enter a valid line.</span>
						</div>
						<div :class="['form-group', errors.addr_l3? 'has-error' : '']">
							<label>Address Line 3</label>
							<input type="text" class="form-control" placeholder="Enter address line 3" v-model="aform.addr_l3">
							<span v-if="errors.addr_l3" :class="['badge bg-danger']">Please enter a valid line.</span>
						</div>
						<div :class="['form-group', errors.city ? 'has-error' : '']">
							<label>City</label>
							<input type="text" class="form-control" placeholder="Enter city" v-model="aform.city">
							<span v-if="errors.city" :class="['badge bg-danger']">Please enter a valid city.</span>
						</div>
						<div :class="['form-group', errors.state ? 'has-error' : '']">
							<label>State</label>
							<input type="text" class="form-control" placeholder="Enter state" v-model="aform.state">
							<span v-if="errors.state" :class="['badge bg-danger']">Please enter a valid state.</span>
						</div>
						<div :class="['form-group', errors.pincode ? 'has-error' : '']">
							<label>Pincode</label>
							<input type="number" class="form-control" placeholder="Enter pincode" v-model="aform.pincode" min="100000">
							<span v-if="errors.pincode" :class="['badge bg-danger']">Please enter a valid pincode.</span>
						</div>
						<div class="form-group">
							<button class="btn btn-danger" type="submit">Submit</button>
						</div>
						</form>
					</div>
					<div class="card-footer">
					<button class="btn btn-secondary" data-dismiss="modal">Close</button>
				</div>
				</div>
				</div>
				</div>

<!-- All VUE Parts end before this comment -->
    </div>
</template>

<script>
		 export default {
        mounted() {
            console.log('Customer Profile mounted.')
        },

        created(){
        	this.getLead();
        	this.getAddresses();
        	this.getDocuments();
        },

        data(){
        	return {
        		form: new Form({
         			name: '',
         			uid: '',
         			gender: '',
         			mobile: '',
         			alt_mobile: '',
         			phone: '',
         			alt_phone: '',
         			email: '',
         			alt_email: '',
         			dob: '',
         			membership_id: '',
         			category: '',
         			area: '',
         			doa: '',
         			id: ''
         		}),
         		errors: [],
         		heading: '',

         		aform: new Form({
         			profile_id: '',
         			addr_l1: '',
         			addr_l2: '',
         			addr_l3: '',
         			city: '',
         			state: '',
         			pincode: '',
         			id: ''
         		}),

         		addresses: [],
         		documents: [],
         		errors: [],
        		doc_name: '',
        		doc_number: '',
        		notes: '',
        		valid_till: '',
        		front: '',
        		back: ''
        	}
        },

        methods: {
        	getLead(){
        		axios.post("/api/getLead", {id: this.$route.params.id})
        		.then(response => {
        			this.form.fill(response.data);
        		})
        	},

        	getDocuments(){
        		axios.post("/api/getDriverDocuments", {id: this.$route.params.driver})
        		.then(response => {
        			this.documents = response.data;
        		})
        	},

        	addFront(){
        		this.front = this.$refs.front.files[0];
        	},

        	addBack(){
        		this.back = this.$refs.back.files[0];
        	},

        	addDocument(){
        		var form = new FormData();
        		form.set("driver_id", this.$route.params.driver);
        		form.set("dp_id", this.$route.params.dp);
        		form.set("doc_name", this.doc_name);
        		form.set("doc_no", this.doc_number);
        		form.set("notes", this.notes);
        		form.set("valid_till", this.valid_till);
        		form.append("front", this.front);
        		form.append("back", this.back);
        		axios({
        			method: 'post',
        			url: '/api/addDriverDocument',
        			data: form,
        			headers: {"Content-Type": "multipart/form-data",}
        		})
        		.then(() => {
        			toast.fire({
        				icon: 'success',
        				title: 'Document Added'
        			});
        			this.errors = [];
        		})
        		.catch((errors) => {
        			this.errors = errors.response.data.errors;
        		});
        	},

        	updateCustomer(){
        		this.form.post("/api/updateCustomer")
        		.then(response => {
        			if(response.data == 200){
        				toast.fire({
        					icon: 'success',
        					title: 'Customer Details Updated'
        				});
        				this.getLead();
        				this.errors = [];
        			}
        			else
        				toast.fire({
        					icon: 'error',
        					title: 'Operation Failed'
        				});
        		})
        		.catch((errors) => {
        			toast.fire({
        				icon: 'error',
        				title: 'Operation Failed'
        			});
        			this.errors = errors.response.data.errors;
        		})
        	},

        	add(){
        		this.heading = "Add";
        		this.aform.profile_id = this.form.id;
        		$("#adrsmodal").modal("show");
        	},

        	change(address){
        		this.heading = "Edit";
        		this.aform.fill(address);
        		$("#adrsmodal").modal("show");
        	},

        	deleteA(id){
        		axios.post("/api/deleteAddress", {id:id})
        		.then(() => {
        			toast.fire({
        					icon: "success",
        					title: "Addresses Updated"
        				});
        				this.getAddresses();
        		})
        		.catch(() => {
        			toast.fire({
        				icon: "success",
        				title: "Failed"
        			});
        		})
        	},

        	updateAddress(){
        		this.aform.post("/api/addLeadAddress")
        		.then(response => {
        			if(response.data == 200){
        				toast.fire({
        					icon: "success",
        					title: "Addresses Updated"
        				});
        				this.errors = [];
        				this.getAddresses();
        			}
        		})
        		.catch((errors) => {
        			toast.fire({
        				icon: "success",
        				title: "Failed"
        			});
        			this.errors = errors.response.data.errors;
        		})
        	},

        	getAddresses(){
        		axios.post("/api/getLeadAddresses", {id: this.$route.params.id})
        		.then(response => {
        			this.addresses = response.data;
        		})
        	}
        }
    }
</script>
